Fancybox.bind('[data-fancybox]', {
  youtube : {
    controls : 1,
    showinfo : 0
  },
  vimeo : {
    color : 'f00'
  }
}); 

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(".logo-list .slider").forEach(function (el, index) {
    new Swiper(el, {
      loop: true,
      speed: 1200,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      
      breakpoints: {
        // Mobile: Show 2-3 logos
        0: { slidesPerView: 2 },      // Very small screens: 2 logos
        375: { slidesPerView: 2.5 },  // Small phones: 2.5 logos
        480: { slidesPerView: 3 },    // Larger phones: 3 logos
        768: { slidesPerView: 4 },    // Tablets: 4 logos
        1120: { slidesPerView: 5 },   // Small desktop: 5 logos
        1230: { slidesPerView: 6 },   // Medium desktop: 6 logos
        1340: { slidesPerView: 7 }    // Large desktop: 7 logos
      }

    });
  });

  const gallerySliders = document.querySelectorAll('.gallery-swiper');

  gallerySliders.forEach(function(sliderEl) {
    new Swiper(sliderEl, {
      slidesPerView: 1.31,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        580: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1366: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  });
});

/**
 * Professional Buy Now functionality
 * Handles cart addition and checkout redirection with proper error handling
 */
(function() {
  'use strict';

  class BuyNowHandler {
    constructor() {
      this.button = document.getElementById('buy-now-button');
      this.isProcessing = false;
      this.init();
    }

    /**
     * Initialize event listeners
     */
    init() {
      if (!this.button) {
        console.warn('Buy Now button not found');
        return;
      }

      this.button.addEventListener('click', this.handleBuyNow.bind(this));
    }

    /**
     * Handle buy now click event
     * @param {Event} event - Click event
     */
    async handleBuyNow(event) {
      event.preventDefault();

      if (this.isProcessing || this.button.disabled) {
        return;
      }

      try {
        this.setLoadingState(true);
        
        const productData = this.getProductData();
        
        if (!this.validateProductData(productData)) {
          return;
        }

        await this.addToCart(productData);
        this.redirectToCheckout();

      } catch (error) {
        this.handleError(error);
      } finally {
        this.setLoadingState(false);
      }
    }

    /**
     * Extract product data from form inputs
     * @returns {Object} Product data
     */
    getProductData() {
      let variantInput;
      
      // Try to find variant input using multiple strategies
      // Strategy 1: Look for main product form (not installment forms)
      variantInput = document.querySelector('form[action*="/cart/add"]:not(.installment) input[name="id"]');
      
      // Strategy 2: If not found, try any form with cart/add action
      if (!variantInput) {
        const productForms = document.querySelectorAll('form[action*="/cart/add"]');
        for (const form of productForms) {
          if (!form.classList.contains('installment')) {
            const input = form.querySelector('input[name="id"]');
            if (input) {
              variantInput = input;
              break;
            }
          }
        }
      }
      
      // Strategy 3: Look for variant picker inputs (radio buttons, select)
      if (!variantInput) {
        variantInput = document.querySelector('input[name="id"]:checked') ||
                       document.querySelector('select[name="id"]');
      }
      
      // Strategy 4: Any input with name="id" that's not in installment form
      if (!variantInput) {
        const allIdInputs = document.querySelectorAll('input[name="id"]');
        for (const input of allIdInputs) {
          const form = input.closest('form');
          if (!form || !form.classList.contains('installment')) {
            variantInput = input;
            break;
          }
        }
      }
      
      const quantityInput = document.querySelector('input[name="quantity"]');
      
      // Get variant ID
      let variantId;
      if (variantInput?.tagName === 'SELECT') {
        variantId = variantInput.value;
      } else if (variantInput?.value) {
        variantId = variantInput.value;
      } else {
        variantId = this.button.dataset.variantId;
      }

      // Debug logging to help troubleshoot
      console.log('Debug - Variant detection:', {
        variantInput: variantInput,
        variantInputForm: variantInput?.closest('form')?.className || 'no-form',
        variantId: variantId,
        buttonDataset: this.button.dataset.variantId,
        allIdInputs: Array.from(document.querySelectorAll('[name="id"]')).map(input => ({
          element: input,
          value: input.value,
          formClass: input.closest('form')?.className || 'no-form',
          formId: input.closest('form')?.id || 'no-id'
        }))
      });
      
      return {
        variantId: variantId,
        quantity: quantityInput?.value ? parseInt(quantityInput.value, 10) : 1
      };
    }

    /**
     * Validate product data before processing
     * @param {Object} data - Product data to validate
     * @returns {boolean} Validation result
     */
    validateProductData(data) {
      const { variantId, quantity } = data;

      if (!variantId) {
        this.showUserMessage('Please select a product variant.', 'error');
        return false;
      }

      if (!quantity || quantity < 1 || quantity > 500000) {
        this.showUserMessage('Please enter a valid quantity (1-500000).', 'error');
        return false;
      }

      return true;
    }

    /**
     * Add product to cart via Shopify API
     * @param {Object} productData - Product data
     * @returns {Promise} Fetch promise
     */
    async addToCart(productData) {
      const { variantId, quantity } = productData;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (!response.ok) {
        const errorData = await this.parseErrorResponse(response);
        throw new Error(this.getErrorMessage(errorData, response.status));
      }

      return response.json();
    }

    /**
     * Parse error response from API
     * @param {Response} response - Fetch response
     * @returns {Object} Error data
     */
    async parseErrorResponse(response) {
      try {
        return await response.json();
      } catch (e) {
        return { message: `HTTP ${response.status}` };
      }
    }

    /**
     * Get user-friendly error message
     * @param {Object} errorData - Error response data
     * @param {number} status - HTTP status code
     * @returns {string} Error message
     */
    getErrorMessage(errorData, status) {
      // Check for Shopify-specific error messages
      if (errorData.description) return errorData.description;
      if (errorData.message) return errorData.message;

      // Fallback messages based on status codes
      const statusMessages = {
        400: 'Invalid request. Please check your selection.',
        404: 'Product not found. Please refresh and try again.',
        422: 'Product is unavailable or out of stock.',
        429: 'Too many requests. Please wait a moment and try again.',
        500: 'Server error. Please try again later.'
      };

      return statusMessages[status] || 'Unable to add item to cart. Please try again.';
    }

    /**
     * Redirect to checkout
     */
    redirectToCheckout() {
      // Small delay to ensure cart is updated
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 100);
    }

    /**
     * Set loading state for button
     * @param {boolean} isLoading - Loading state
     */
    setLoadingState(isLoading) {
      this.isProcessing = isLoading;
      
      const textSpan = this.button.querySelector('.btn-text');
      const loaderSpan = this.button.querySelector('.btn-loader');

      if (isLoading) {
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
        if (textSpan) textSpan.style.display = 'none';
        if (loaderSpan) loaderSpan.style.display = 'inline';
      } else {
        this.button.disabled = false;
        this.button.setAttribute('aria-disabled', 'false');
        if (textSpan) textSpan.style.display = 'inline';
        if (loaderSpan) loaderSpan.style.display = 'none';
      }
    }

    /**
     * Handle errors with logging and user notification
     * @param {Error} error - Error object
     */
    handleError(error) {
      // Log detailed error for debugging
      console.error('Buy Now Error:', {
        message: error.message,
        stack: error.stack,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      });

      this.showUserMessage(error.message, 'error');
    }

    /**
     * Show message to user
     * @param {string} message - Message to display
     * @param {string} type - Message type ('error', 'success', 'info')
     */
    showUserMessage(message, type = 'info') {
      // Simple alert fallback - replace with your notification system
      alert(message);
      
      // Example for custom notification system:
      // if (window.showNotification) {
      //   window.showNotification(message, type);
      // } else {
      //   alert(message);
      // }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new BuyNowHandler());
  } else {
    new BuyNowHandler();
  }

})();